<script setup>
import { ref, watch, nextTick, onMounted} from "vue"
import axiosIns from "@/plugins/axios.js"
import Banner from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/banner.vue'
import JobCard from "@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/job_card.vue"
import Footer from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/footer.vue'

const id_applicant = JSON.parse(localStorage.getItem('userData'))?.id_usuario
const filteredData = ref(null)
const allData = ref(null)
const favorites = ref([])

const getData = () => {

    const params = {
        id_applicant : id_applicant,
    }

    const config = {
        method: "post",
        url: "/talentoagv/getApplicantionsMade/",
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    };

    axiosIns(config)
    .then(function (response) {
        if (response.data["is_error"] === false) {
            let resultado = response.data["result"];
            allData.value = resultado;
            filteredData.value = resultado;

            if (id_applicant) {
                getFavorites()
            }

        }
    })
    .catch(function (error) {
        console.log(error);
    });
}

const getFavorites = () => {

    const params = {
        applicant_id : id_applicant,
    }

    const config = {
        method: "post",
        url: "/talentoagv/getFavoriteOffers/",
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    };

    axiosIns(config)
    .then(function (response) {
        favorites.value = response.data["result"];
        for (let a of filteredData.value) {
            a.isfavorite = favorites.value.some(b => a.id === b.key_oferta_lab)
        }

    })
    .catch(function (error) {
        console.log(error);
    });

}

onMounted(() => {
    getData()
})

</script>
<template>
    <Banner/>
    <div class="container my-5">
        <div class="row mb-4">
            <div class="col-12 col-md-8">
                <h6 class="text-agv-siete" style="font-weight: bold; cursor: pointer;" @click="getData" title="Actualizar mis postulaciones">
                    <i class="fa-solid fa-flag"></i>
                    &nbsp;Mis Postulaciones
                </h6>
            </div>
            <div class="col-12 col-md-4" style="display: flex; justify-content: end; flex-wrap: wrap;">
                <router-link v-if="id_applicant" class="text-muted me-4" to="/favoritos">
                    <i class="fa-solid fa-heart"></i>
                    Mis Favoritos
                </router-link>

                <h6 class="text-end" style="text-decoration: underline; text-underline-offset: 6px; color: #1957d1;">
                    <router-link class="text-agv-siete" to="/dashboard_ofertas_laborales">
                        <i class="fa-solid fa-briefcase me-1"></i>
                        &nbsp;Puestos de Trabajo
                    </router-link>
                </h6>
            </div>
        </div>
        <div class="row">
            <template v-for="(job, index) in filteredData" :key="job.id">
                <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                    <!-- Cambiar img por job.s3_url -->
                    <div class="content-job-card">
                        <JobCard
                        :id="job.id"
                        :title="job.work_pos"
                        :vacancies="job.n_vacancy"
                        :place="job.place"
                        :isfavorite="job.isfavorite"
                        :isapplicated="true"
                        :image="job.s3_url"
                        />
                    </div>
                </div>
            </template>
        </div>
    </div>
    <Footer/>
</template>
<style scoped>

.content-job-card {
    margin-top: 100px;
    display: flex;
    justify-content: center;
}

.topbar-link {
    background: transparent;
    border: 0;
    padding: 0;
    color: var(--bg-primary-as);
    display: inline-flex;
    align-items: center;
    font-weight: 500;
    cursor: pointer;
}

.btn-link-reset {
    background: none;
    border: 0;
    padding: 0;
    color: var(--bg-primary-as-light);
    font-weight: 500;
    cursor: pointer;
}

.btn-link-reset:hover {
    text-decoration: underline;
}

</style>